import { render, staticRenderFns } from "./ComponenteSolicitacaoHistorico.vue?vue&type=template&id=66cf2cb3"
import script from "./ComponenteSolicitacaoHistorico.vue?vue&type=script&lang=js"
export * from "./ComponenteSolicitacaoHistorico.vue?vue&type=script&lang=js"
import style0 from "./ComponenteSolicitacaoHistorico.vue?vue&type=style&index=0&id=66cf2cb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports